import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { LoadingPane, ModalWindow, accessibilityNotificationsEmitter } from '../../common';
import SingleMessage from './single-message';
import * as messageConstants from './message-constants';
import { track } from '../../tracking';
import './messages.scss';

export class MessagesComponent extends Component {

  componentDidMount() {
    const { fetchMessages } = this.props;
    fetchMessages();
  }

  componentWillUpdate(nextProps, nextState) {
    const { messagesState, fetchMessages } = nextProps;
    const { isFetching, isValid } = messagesState || {};
    if(!messagesState || !(isFetching || isValid))
      fetchMessages();
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedMessage : previousMessage } = prevProps;
    const { selectedMessage } = this.props;
    if(selectedMessage && !previousMessage) {
      var confirmDismiss = document.getElementById('confirm-dismiss');
      if(confirmDismiss) confirmDismiss.focus();
    }
  }

  mapItem(item) {
    const { participantInfo } = this.props;
    const { messageViewDateUtc } = participantInfo || {};

    return (
      <SingleMessage key={item.id} item={item} messageViewDateUtc={messageViewDateUtc} handleDismiss={id => this.handleOpenModal(id)}/>
    );
  }

  handleOpenModal(id) {
    const { openModal } = this.props;
    accessibilityNotificationsEmitter.assertive(messageConstants.modalText);
    openModal(id);

    track.event.dashboard.message.dismiss();
  }

  handleDismiss(id) {
    const { openModal, dismissMessage } = this.props;
    dismissMessage(id);
    openModal(null);
    accessibilityNotificationsEmitter.assertive(messageConstants.dismissText);
  }

  render() {
    const { messagesState, selectedMessage, viewAllMessages, openModal } = this.props;
    const { isFetching, err, data } = messagesState || {};
    const { totalResults, results } = data || {};

    if(results && results.length === 0)
      return null;

    return (
      <div>
        <ModalWindow
          show={!!selectedMessage}
          onClose={e => openModal(null)}
          title='Dismiss Notification'
          footer={(
            <div>
              <button
                id='confirm-dismiss'
                className='btn btn-primary'
                onClick={e => this.handleDismiss(selectedMessage)}>
                Yes
              </button>
              <button
                id='cancel-dismiss'
                className='btn btn-default'
                onClick={e => openModal(null)}>
                No
              </button>
            </div>
          )}>
          {messageConstants.modalText}
        </ModalWindow>
        <LoadingPane isLoading={isFetching && !data} err={err} loadingMessage="Loading Notifications...">
          <div className="messageSection widget">
            <h3 className="widget-title">Notifications</h3>
            {results && results.map((item) => this.mapItem(item))}
            { totalResults && totalResults > 5 ? (
              <button
                id='view-all'
                className='btn btn-primary'
                onClick={e => viewAllMessages()}>
                View All {totalResults}
              </button>
            ) : null}
          </div>
        </LoadingPane>
      </div>
    );
  }
}

MessagesComponent.propTypes = {
  participantInfo: PropTypes.object,
  messagesState : PropTypes.object,
  selectedMessage : PropTypes.string,
  dismissalStates : PropTypes.object,
  fetchMessages : PropTypes.func,
  dismissMessage : PropTypes.func,
  openModal : PropTypes.func,
  viewAllMessages : PropTypes.func,
};

export default MessagesComponent;



// WEBPACK FOOTER //
// src/dashboard/messages/messages.js